import { ResponseCodesFactory } from "../factories";
import { Controllers } from "../models";
import { StringSanitizer } from "../utils/StringSanitizer";

export abstract class BaseClient {
  protected readonly _apiEndpoint: string;
  private readonly _sanitizer: StringSanitizer;
  private readonly _headers: Headers;
  private readonly _responseFactory: ResponseCodesFactory;

  constructor(defaultRequestHeaders: Headers, apiEndpoint: string) {
    this._sanitizer = new StringSanitizer();
    this._responseFactory = new ResponseCodesFactory();

    this._apiEndpoint = apiEndpoint;
    this._headers = defaultRequestHeaders;
  }

  protected api = async <T>(
    controller: Controllers,
    id?: string,
    method?: "GET" | "POST" | "PUT" | "DELETE",
    body?: any,
    queryParams?: string,
    toevoeging?: string,
    headers?: { key: string; value: string }[]
  ) => {
    const sanitizedUrl = this._sanitizer.sanitizeApiEndpoint(
      this._apiEndpoint,
      controller,
      id,
      queryParams,
      toevoeging
    );
    const json = body ? JSON.stringify(body) : undefined;

    const requestHeaders = new Headers(this._headers);
    if (headers)
      headers.forEach((header: { key: string; value: string }) =>
        requestHeaders.append(header.key, header.value ?? "")
      );

    const resolvedMethod = method ?? "GET";
    const maxAttempts = 3;
    let lastResponse: Response = new Response(null, { status: 418, statusText: "" });

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      if (attempt > 0) await new Promise((resolve) => setTimeout(resolve, 500));
      try {
        const fetchCall = await fetch(sanitizedUrl, {
          credentials: "include",
          method: resolvedMethod,
          body: json,
          headers: requestHeaders,
        });

        if (fetchCall.ok || fetchCall.status === 400) return this.handleResponse<T>(controller, fetchCall);
        lastResponse = new Response(fetchCall.body ?? undefined, {
          status: fetchCall.status,
          statusText: fetchCall.statusText,
        });
      } catch (e: any) {
        lastResponse = new Response(e.body, { status: e.status ?? 418, statusText: e.message ?? "" });
      }
    }

    return this.handleResponse<T>(controller, lastResponse);
  };

  protected handleResponse = async <T>(
    controller: Controllers,
    response: Response
  ): Promise<{ response: Response; json?: T; headers: Headers }> => {
    console.log("=====> RESPONSE", response);
    console.log("=====> HEADERS", response.headers);
    if (!response.ok) {
      const error = new Error(this._responseFactory.create(controller, response.status));
      throw error;
    }

    const contentType = response.headers.get("content-type");

    console.log("=========> All Headers Keys");
    for (let entry in response.headers.keys()) console.log(entry);
    console.log("=========> All Headers Keys");

    console.log("=========> All Headers Entries");

    for (let entry in response.headers.entries()) console.log(entry);

    console.log("=========> All Headers Entries");

    if (!contentType) return { response: response, headers: response.headers };

    const isJsonContent = contentType.includes("application/json") || contentType.includes("application/hal+json");

    if (isJsonContent) {
      return {
        json: await response.json(),
        headers: response.headers,
        response: response,
      };
    }

    return {
      response: response,
      headers: response.headers,
    };
  };
}
